import React from 'react'
import { Text, StyleSheet, Dimensions } from 'react-native-web'
import { COLORS } from '@utils/colors'
import { PrimaryTextProps } from '@Interfaces/Component/PrimaryTextInterface'

const WIDTH_OF_DESIGN_SCREEN = 1792
const minFontSize = 10

export const PrimaryText: React.FC<PrimaryTextProps> = ({
  fontSize = 12,
  fontWeight,
  lineHeight,
  color,
  style: customStyles,
  numberOfLines,
  ignoreScaling = false,
  children,
  ...props
}) => {
  const [width, setWidth] = React.useState<number>(
    Dimensions.get('window').width < 1792 ? Dimensions.get('window').width : 1792
  )

  React.useEffect(() => {
    const handleChange = ({
      window: win,
    }: {
      screen: any
      window: { width: number; height: number }
    }) => {
      if (win.width > 1024 && win.width < 1792) {
        setWidth(win.width)
      }
    }

    const subscription = Dimensions.addEventListener('change', handleChange)
    return () => {
      subscription.remove()
    }
  }, [setWidth])

  const style = styles(fontSize, width, fontWeight, color, lineHeight, ignoreScaling)
  return (
    <Text
      style={[style.title, customStyles]}
      numberOfLines={numberOfLines ? numberOfLines : 0}
      {...props}
    >
      {children}
    </Text>
  )
}

const styles = (
  fontSize: number,
  screenWidth: number,
  fontWeight?: number | string,
  color?: string,
  lineHeight?: number,
  ignoreScaling?: boolean
) => {
  const font = (fontSize / WIDTH_OF_DESIGN_SCREEN) * screenWidth
  const fontHeight = (font > minFontSize ? font : minFontSize) * (lineHeight || 1.25)

  return StyleSheet.create({
    title: {
      fontSize: ignoreScaling ? fontSize : font > minFontSize ? font : minFontSize,
      lineHeight: ignoreScaling ? '125%' : fontHeight,
      color: color || COLORS.primary.darkBlue,
      fontFamily: 'Montserrat',
      fontWeight,
      textAlign: 'left',
      textAlignVertical: 'middle',
      overflowWrap: 'normal',
    },
  })
}
